module.exports = __webpack_public_path__ + "img/P3.1383e219.png";